<template>
  <div class="gov-title">
    <div class="addTitle">
      <div class="titleName">实体服务</div>
    </div>
    <div class="entityServe">
      <div class="gov-title1">
        <div class="gov-title2">
          <div>类型</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              ref="zfyzTypeName"
              v-model="addForm.entityType"
              placeholder="请选择"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option label="居家" :value="0"></el-option>
              <el-option label="机构" :value="1"></el-option>
              <el-option label="社区" :value="2"></el-option>
              <!-- <el-option label="在用" :value="1"></el-option>
                            <el-option label="注销" :value="2"></el-option> -->
            </el-select>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>服务状态</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityStatus"
              placeholder="请选择"
              ref="zfyzStatusName"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option label="待签约" :value="1"></el-option>
              <el-option label="已签约" :value="2"></el-option>
              <el-option label="注销" :value="3"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="gov-title1">
        <div class="gov-title2">
          <div>机构</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityStation"
              ref="zfyzEntityName"
              placeholder="请选择"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option
                v-for="item in serviceStationList"
                :key="item.selectTreeId"
                :label="item.statName"
                :value="item.selectTreeId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>服务人员</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityServicePersonId"
              ref="zfyzServeName"
              placeholder="请选择"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option
                :label="item.personName"
                :value="item.id"
                v-for="(item, index) in personList"
                :key="index"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="gov-title1">
        <div class="gov-title2 right-title-3 right-title-4">
          <div>每月金额</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.yearMoney"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="addTitle">
      <div class="titleName">信息服务</div>
    </div>
    <div class="infoServe">
      <el-table
        :data="equipmentList"
        border
        style="width: 100%; margin-top: 20px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="设备类型"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="vendorName"
          label="供应商"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="equSerial"
          label="IMEI号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="years"
          label="年限"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="useStatus"
          label="状态"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.useStatus == 1">待签约</span>
            <span v-if="scope.row.useStatus == 2">在用</span>
            <span v-if="scope.row.useStatus == 3">注销</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pages"
        background
        layout="total, prev, pager, next"
        @current-change="handleCurrentChangeOne"
        :total="pageOne.total"
        :current-page.sync="pageOne.pageNo"
        :page-size="10"
      >
      </el-pagination>
    </div>
    <div class="addTitle">
      <div class="titleName">工单列表</div>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="servePersonName"
          label="服务人员"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="timeStart"
          label="开始时间"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="timeEnd"
          label="结束时间"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="price"
          label="套餐金额"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="balance"
          label="余额"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pages"
        background
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"
        :total="page.total"
        :current-page.sync="page.pageNo"
        :page-size="10"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request.js"

export default {
  props: {
    formData: {},

    setTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      page: { pageNo: 1, pageSize: 10, total: 0 },
      pageOne: { pageNo: 1, pageSize: 10, total: 0 },
      tableData: [],
      equipmentList: [],
      personList: [],
      serviceStationList: [],
      data: {},
      addForm: {
        entityType: "",
        entityTypeDesc: "",
        entityStatus: "",
        entityStatusDesc: "",
        entityStation: "",
        entityStationName: "",
        entityServicePersonId: "",
        entityServicePersonName: "",
        yearMoney: "",
      },
    }
  },
  created() {
    this.getPerson()
    this.getStation()
  },
  watch: {
    formData: {
      handler(val) {
        console.log(this.addForm, "this.addForm")
        if (this.formData.id) {
          this.getInfo()
          this.getWorks()
          this.getPerson()
          this.getStation()
          if (val.zfAssistance) {
            this.addForm = {
              entityType: val.zfAssistance.entityType
                ? Number(val.zfAssistance.entityType)
                : "",
              entityTypeDesc: val.zfAssistance.entityTypeDesc
                ? val.zfAssistance.entityTypeDesc
                : "",
              entityStatus: val.zfAssistance.entityStatus
                ? Number(val.zfAssistance.entityStatus)
                : "",
              entityStatusDesc: val.zfAssistance.entityStatusDesc
                ? val.zfAssistance.entityStatusDesc
                : "",
              entityStation: val.zfAssistance.entityStation
                ? Number(val.zfAssistance.entityStation)
                : "",
              entityStationName: val.zfAssistance.entityStationName
                ? val.zfAssistance.entityStationName
                : "",
              entityServicePersonId: val.zfAssistance.entityServicePersonId
                ? Number(val.zfAssistance.entityServicePersonId)
                : "",
              entityServicePersonName: val.zfAssistance.entityServicePersonName
                ? val.zfAssistance.entityServicePersonName
                : "",
              yearMoney: val.zfAssistance.yearMoney
                ? val.zfAssistance.yearMoney
                : "",
            }
            this.$forceUpdate()
          } else {
            this.addForm = {
              entityType: "",
              entityTypeDesc: "",
              entityStatus: "",
              entityStatusDesc: "",
              entityStation: "",
              entityStationName: "",
              entityServicePersonId: "",
              entityServicePersonName: "",
              yearMoney: "",
            }
          }
          this.wUpdata()
        }
        if (val.hide) {
          this.addForm = {
            entityType: "",
            entityTypeDesc: "",
            entityStatus: "",
            entityStatusDesc: "",
            entityStation: "",
            entityStationName: "",
            entityServicePersonId: "",
            entityServicePersonName: "",
            yearMoney: "",
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getInfo() {
      request({
        url: "/jjyl/admin/thinsEquManage/info/findListByPerson",
        method: "POST",
        data: {
          pageNo: this.pageOne.pageNo,
          pageSize: this.pageOne.pageSize,
          idCard: this.formData.idCard,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (!res.content) {
            this.equipmentList = []
            this.pageOne.total = 0
          } else {
            this.equipmentList = res.content.list || []
            this.pageOne.total = res.content.count || 0
          }
        }
      })
    },
    // 机构
    getStation() {
      request({
        url: "/ypt/admin/serviceStation/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            return
          }
          this.serviceStationList = res.content.list.map((item) => {
            return {
              selectTreeId: item.id, //id
              statName: item.statName,
            }
          })
        }
      })
    },
    //服务人员
    getPerson() {
      request({
        url: "/ypt/admin/serviceStaff/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 10000,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.personList = []
            return
          }
          this.personList = []
          this.personList = res.content.list
        }
      })
    },
    getWorks() {
      request({
        url: "/jjyl/servicePgd/plan/info/findPlanPgdList",
        method: "POST",
        data: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          idCard: this.formData.idCard,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (!res.content) {
            this.tableData = []
            this.page.total = 0
          } else {
            this.tableData = res.content.list || []
            this.page.total = res.content.count || 0
          }
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNo = val
      this.getWorks()
    },
    handleCurrentChangeOne() {
      this.pageOne.pageNo = val
      this.getInfo()
    },
    wUpdata() {
      this.addForm.entityTypeDesc = this.$refs.zfyzTypeName.selectedLabel
      this.addForm.entityStatusDesc = this.$refs.zfyzStatusName.selectedLabel
      this.addForm.entityStationName = this.$refs.zfyzEntityName.selectedLabel
      this.addForm.entityServicePersonName =
        this.$refs.zfyzServeName.selectedLabel
      console.log(this.$refs.zfyzTypeName, "this.$refs.zfyzTypeName.")

      console.log(this.addForm)
      this.$emit("governmentAssistance", this.addForm)
    },
  },
}
</script>

<style lang="less" scoped>
.gov-title {
  width: 98%;
  margin-left: 2%;
}
.gov-title1 {
  width: 100%;
  display: flex;
}
.gov-title2 {
  width: 50%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
}
.gov-title2 > div:first-child {
  width: 140px;
  height: 50px;
  line-height: 50px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}
.gov-title2 > div:nth-child(2) {
  height: 50px;
  line-height: 50px;
  margin: 0 20px;
}
.right-title-2 {
  border-top: 1px solid #c0c4cc;
}
.right-title-3 {
  border-right: 1px solid #c0c4cc;
}
.right-title-4 {
  /deep/.el-input__inner {
    border: none;
  }
}
.gov-title5 {
  width: 100%;
  display: flex;

  border-bottom: 1px solid #c0c4cc;
}
.gov-title5 > div:first-child {
  width: 140px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}
.gov-title5 > div:nth-child(2) {
  width: calc(100% - 140px);

  /deep/.el-textarea__inner {
    border: none;
    resize: none;
  }
}
.pages {
  margin-top: 20px;
}
.flexBox {
  flex: 1;
}
.selectBorder {
  width: 100%;
  /deep/.el-input__inner {
    border: none;
  }
}
.addTitle {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  display: flex;
  line-height: 40px;
  .titleName {
    flex: 1;
    color: #409eff;
    font-size: 15px;
  }
  .fontSize {
    font-weight: bold;
    color: #409eff;
    line-height: 40px;
    cursor: pointer;
  }
}
.infoServe {
  margin-top: 20px;
  .infoItem {
    display: flex;
    flex-wrap: wrap;
    .serveFlex {
      width: 25%;
      margin-bottom: 15px;
      .serveContent {
        padding: 0 15px;
        display: flex;
        // margin-bottom: 10px;
        .serveName {
          width: 90px;
          padding-right: 10px;
          text-align: right;
          color: #606266;
          font-size: 14px;
          line-height: 40px;
        }
        .serveSign {
          flex: 1;
        }
      }
    }
    .delIcon {
      cursor: pointer;
      font-size: 20px;
      position: relative;
      top: 10px;
    }
  }
}
.entityServe {
  margin-top: 20px;
  border-top: 1px solid rgba(167, 164, 164, 0.8);
}
</style>
